/**
 * Calculates the total calories from fat based on provided ingredients.
 */
export function calculateTotalCaloriesFromFat(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalCaloriesFromFat = [...ingredients].reduce(addCaloriesFromFat, 0);

  return Math.round(totalCaloriesFromFat);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.caloriesFromFat !== 'number';
}

function addCaloriesFromFat(total: number, ingredient: Ingredient) {
  const caloriesFromFat = typeof ingredient.caloriesFromFat === 'number' ? ingredient.caloriesFromFat : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + caloriesFromFat * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { caloriesFromFat: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
